import axios from 'axios';
import { reactAppConfig } from '@/config/react-app-config';

const backend = axios.create({
  baseURL: reactAppConfig.backendUrl
});

export default backend;
